import { define } from 'remount'
import NavBar from "./components/NavBar"
import Table from "./components/Table"
import ResultsPage from "./components/ResultsPage"
import Submission from "./components/Submission"
import SubmissionZip from "./components/SubmissionZip"
import DashboardTable from './components/DashboardTable'
import UploadTable from './components/UploadTable'
import AnalyzeTable from './components/AnalyzeTable'
import DataAnalysesTable from './components/DataAnalysesTable'
import ProjectResultGenerator from './components/ProjectResultGenerator'
import KitGrid from './components/KitGrid'
import Chromatogram from './components/Chromatogram'
import QAQC from './components/QAQC'
import SystemPerformanceAssessmentForm from './components/SystemPerformanceAssessmentForm'
import {
    TbChartAreaIcon,
    TbChartAreaFilledIcon,
    VscGraphLineIcon,
    TiChartAreaIcon,
    FaBugIcon,
} from './components/Icons'


define({
    'navbar-component': NavBar,
    'table-component': Table,
    'dashboardtable-component': DashboardTable,
    'analyzetable-component': AnalyzeTable,
    'uploadtable-component': UploadTable,
    'results-component': ResultsPage,
    'submission-component': Submission,
    'submissionzip-component': SubmissionZip,
    'dataanalysestable-component': DataAnalysesTable,
    'projectresultgenerator-component': ProjectResultGenerator,
    'kitgrid-component': KitGrid,
    'chromatogram-component': Chromatogram,
    'qaqc-component': QAQC,
    'spa-form-component': SystemPerformanceAssessmentForm,
    // Icons
    'tb-chart-area-icon': TbChartAreaIcon,
    'tb-chart-area-filled-icon': TbChartAreaFilledIcon,
    'vsc-graph-line-icon': VscGraphLineIcon,
    'ti-chart-area-icon': TiChartAreaIcon,
    'fa-bug-icon': FaBugIcon,
})
